<template>
    <div>
        <b-container fluid="xl" class="bv-example-row">
            <b-row>
                <b-col md="4">
                    <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
                </b-col>
            </b-row>
        </b-container>
        <span v-if="loading">
            <b-spinner label="Spinning"></b-spinner>
        </span>
        <span v-else>
            <save-config-settings
                :device-id="savedConfiguration.id"
                :device-type-id="savedConfiguration.deviceTypeId"
                :settings="savedConfiguration.settings"
                :parameters="savedConfiguration.parameters"
                :id="id"
            />
        </span>
    </div>
</template>

<script>
    import axios from "axios";
    import SaveConfigSettings from "./SaveConfigSettings";


    export default {
        name: "SavedConfig",
        components: {SaveConfigSettings},
        props: [
            "id"
        ],
        data() {
            return {
                loading: true,
                breadcrumb: [
                    {
                        text: this.$t('menu.configurations'),
                        href: '#/saved-configurations'
                    }, {
                        text: this.$t('menu.configurations_settings')
                    }
                ],
                deviceTypeId: null,
                savedConfiguration: {
                    id: null,
                    deviceTypeId: null,
                    settings: null,
                    parameters: {
                        'isActive': false,
                        'isDefault': false,
                        'description': false,
                    }
                }
            }
        },
        mounted() {
           let props = this;
            axios
                .get('api/v1/saved-configurations/' + props.id)
                .then((data) => {
                    const savedConfiguration = data.data.data;
                    this.savedConfiguration.deviceTypeId = savedConfiguration.deviceTypeId;
                    this.savedConfiguration.id = savedConfiguration.id;
                    this.savedConfiguration.settings = savedConfiguration.settings;

                    this.savedConfiguration.parameters.isActive = savedConfiguration.isActive;
                    this.savedConfiguration.parameters.isDefault = savedConfiguration.isDefault;
                    this.savedConfiguration.parameters.description = savedConfiguration.description;
                    this.savedConfiguration.parameters.name = savedConfiguration.name;

                    this.loading = false;
                })
                .catch(() => undefined);
        }
    }
</script>

<style scoped>

</style>